import { render, staticRenderFns } from "./AdminSupplierWallet.vue?vue&type=template&id=499a8380&"
import script from "./AdminSupplierWallet.vue?vue&type=script&lang=js&"
export * from "./AdminSupplierWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports